import { render, staticRenderFns } from "./paginator.vue?vue&type=template&id=0c766d71&"
import script from "./paginator.vue?vue&type=script&lang=js&"
export * from "./paginator.vue?vue&type=script&lang=js&"
import style0 from "./paginator.vue?vue&type=style&index=0&id=0c766d71&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports